const translations = {
    noResults: 'No matching results',
    searchPlaceholder: 'Search…'
};

export default translations;
